<template lang="pug">
  .email-capture-form
    form(@submit.prevent="submitEmail")
      MrEmailInput(v-model="email" :valid.sync="validEmail" autofocus :disabled="loading")
      button.mr-btn.btn-secondary.submit-button.max-at-tweak(:class="{ disabled: !validEmail }" :disabled="!validEmail" type="submit" data-mr-ass="email-submit-button") Submit

    .captcha(v-if="showCaptcha")
      Captcha(@captcha-response="onCaptchaResponse")

    p.email-in-use-message.feedback-color-1.xs-f-xsmall.sm-f-xxsmall.max-at-tweak.mb-10(v-if="emailInUse")
      | Email already subscribed. Try a different email.

</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex';
  import { EMAIL_CAPTURE_DEFAULT_CONFIG } from '../constants';
  import { getObjProperty } from '@utilities/mrVueUtils';
  import { createCustomerFromEmailCapture } from '@services/vueCustomerSvc';
  import MrEmailInput from '@components/MrEmailInput';
  import Captcha from '@components/captcha';

  const defaultPromoCode = EMAIL_CAPTURE_DEFAULT_CONFIG.code;
  const defaultEmailSource = EMAIL_CAPTURE_DEFAULT_CONFIG.email_source;

  const EMAIL_CAPTURE_HCB = 'email capture hcb';

  export default {
    name: 'EmailCaptureForm',

    components: {
      MrEmailInput,
      Captcha,
    },

    inject: ['getObjProperty'],

    props: {
      type: {
        type: String,
        required: true,
      },

      code: {
        type: String,
        default: defaultPromoCode,
      },

      emailSource: {
        type: String,
        default: defaultEmailSource,
      },
    },

    data: () => ({
      email: null,
      captchaResponse: null,
      loading: false,
      validEmail: false,
      showCaptcha: false,
      emailInUse: false,
    }),

    computed: {
      ...mapGetters('emailCapture', [
        'subscribed',
      ]),
    },

    methods: {
      ...mapActions(['notifyError']),
      ...mapActions('emailCapture', [
        'trackEvent',
      ]),

      ...mapMutations('emailCapture', [
        'setSubscribed',
      ]),

      ...mapActions('customer', [
        'refreshCustomerCdata',
        'getMarketingPreferences',
      ]),

      onCaptchaResponse(response) {
        this.captchaResponse = response;
        this.submitEmail();
      },

      async submitEmail() {
        if (!this.validEmail) {
          return;
        }

        this.loading = true;
        this.emailInUse = false;
        this.showCaptcha = false;
        this.createCustomerWithPromo().then((response) => {
          const offerApplied = !!this.getObjProperty(response, 'data.offerApplied');

          this.loading = false;

          if (!offerApplied) {
            this.emailInUse = true;
            return;
          }

          let variation;
          if (window.location.pathname.indexOf('/colorbar') === 0) {
            variation = EMAIL_CAPTURE_HCB;
          }

          if (this.type === 'modal') {
            this.trackEvent('emailCaptureModalSubmit', {
              variation,
            });
          } else {
            this.trackEvent('emailCaptureFooterSubmit');
          }

          this.refreshCustomerCdata()
            .then(this.getMarketingPreferences)
            .then(() => {
              this.$emit('email-submitted');
              this.setSubscribed(true);
            });
        }).catch((err) => {
          this.loading = false;
          const code = getObjProperty(err, 'response.data.code');

          if (['MISSING_PASSWORD', 'USER_ALREADY_EXISTS'].includes(code)) {
            this.emailInUse = true;
            return;
          }

          if (code === 'CAPTCHA') {
            this.showCaptcha = true;
            return;
          }

          this.notifyError({ err });
        });
      },

      createCustomerWithPromo() {
        return createCustomerFromEmailCapture({
          offerCode: this.code,
          isBookingOfferCode: this.code !== defaultPromoCode,
          captchaResponse: this.captchaResponse,
          email: this.email,
          email_source: this.emailSource,
          skipPassword: true,
        });
      },
    },
  };
</script>

<style lang="stylus">
  .email-capture-form
    overflow hidden

    form
      display flex

      .mr-email-input
        flex-basis 100%

      .mr-btn
        height 45px
        padding 0.5em 1em
        margin 0 0 0 -0.3em

    @media mq-mobile
      form
        display block

        .mr-btn
          width 100%
          margin 0.5em 0 0 0
          height initial
</style>
